module.exports = __webpack_public_path__ + "img/logo_fit-service.453a7548.svg";